import Vue from "vue";
import { CallbackEvent } from '@/core/Utility/CallbackEvent.js';
/**
 * setter
 * @method setCampaign
 * @method setTitle
 * @method setTag
 * @method clearModal
 * action
 * @method show
 * @method hide
 * set event callback
 * @method onCLickConfirm
 * @method onClickCancel
 * event
 * @event sendCallbackConfirm
 * @event sendCallbackCancel
 */
export function ConfirmRedeemModalController () {
    this.campaign = '';
    this.campaignGroup = '';
    this.isAmbassadorCat = false;
    this.tag = '';
    this.busModal = new Vue();

    this.cbConfirm = new CallbackEvent();
    this.cbCancel = new CallbackEvent();
    //custom
    this.cbSendToFriend = new CallbackEvent();

    //#region setter
    this.setCampaign = function (campaign) {
        this.campaign = campaign;
        return this;
    };
    this.setCampaignGroup = function (campaignGroup) {
        this.campaignGroup = campaignGroup;
        return this;
    };
    this.setIsAmbassadorCat = function (isAmbassadorCat) {
        this.isAmbassadorCat = isAmbassadorCat;
        return this;
    };
    this.setTag = function (tag) {
        this.tag = tag;
        return this;
    };
    this.clearModal = function () {
        this.campaign = null;
        this.campaignGroup = '';
        this.isAmbassadorCat = false;
        this.tag = '';
        this.cbConfirm.clearCallback();
        this.cbCancel.clearCallback();
        //custom
        this.cbSendToFriend.clearCallback();

        return this;
    };
    //#endregion setter
    //#region action
    this.show = function () {
        var config = {
            campaign: this.campaign,
            campaignGroup: this.campaignGroup,
            isAmbassadorCat: this.isAmbassadorCat,
            tag: this.tag
        };
        this.busModal.$emit('show', config);
    };
    this.hide = function () {
        this.busModal.$emit('hide');
    };
    //#endregion action
}
